import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import {
  ComponentModalConfig,
  ModalSize,
  SuiModal,
} from '@richardlt/ng2-semantic-ui';

interface ICompanyDetailViewModalContext {
  data?: any;
  title: string;
}

@Component({
  selector: 'app-company-detail-view-modal',
  templateUrl: './company-detail-view-modal.component.html',
  styleUrls: ['./company-detail-view-modal.component.scss'],
})
export class CompanyDetailViewModalComponent implements OnInit {
  pending: boolean = false;
  history = [
    {
      dateCreated: '2018-08-28T03:40:46.785+0000',
      user: 'Aliyu',
      status: 'VERIFIED',
      editedOn: '2022-08-28T05:10:46.785+0000',
      id: 1,
    },

    {
      dateCreated: '2018-08-28T03:40:46.785+0000',
      user: 'Aliyu',
      status: 'VERIFIED',
      editedOn: '2022-08-28T05:10:46.785+0000',
      id: 2,
    },
  ];
  constructor(
    @Inject(DOCUMENT) private document,
    private fb: FormBuilder,
    public modal: SuiModal<ICompanyDetailViewModalContext, void, void>
  ) {}

  ngOnInit(): void {}

  submit() {}
}

export class CompanyDetailViewModal extends ComponentModalConfig<
  ICompanyDetailViewModalContext,
  void,
  void
> {
  constructor(title: string, data?: any, size: ModalSize = ModalSize.Mini) {
    super(CompanyDetailViewModalComponent, { title, data });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
